import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';

export type AppDownloadTemplateProps = {
  title: ReactNode;
  lead?: ReactNode;
  /** The official App Store and Google Play badges (official artwork only). */
  storeBadges: ReactNode;
  /** A PhoneFrame showing the real For you screen built from the same components. */
  phone: ReactNode;
  /** Three feature Cards with illustrations. */
  features?: ReactNode;
  className?: string;
};

/** The app page (/app): store badges, the real app screen in a plain frame, three features. No ratings unless real. */
export function AppDownloadTemplate({
  title,
  lead,
  storeBadges,
  phone,
  features,
  className,
}: AppDownloadTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section py-jc-section">
        <section className="grid items-center gap-jc-section lg:grid-cols-2">
          <div className="flex flex-col gap-5">
            <h1 className="type-hero text-jc-ink">{title}</h1>
            {lead ? <p className="max-w-xl text-base text-jc-ink-secondary">{lead}</p> : null}
            <div className="flex flex-wrap items-center gap-3">{storeBadges}</div>
          </div>
          <div className="flex justify-center">{phone}</div>
        </section>
        {features ? <div className="grid gap-4 md:grid-cols-3">{features}</div> : null}
      </div>
    </PageContainer>
  );
}
